import React from 'react'

// Antd
import { Layout } from 'antd';
import { Route, Switch, Redirect } from 'react-router-dom';

import Home from '../../Home';
import Cources from '../../Cources';
import users from '../../Users';

import './style.scss';
import Course from '../../Cources/Course';
import EditCourse from '../../Cources/Course/EditCourse';
import ContentQuiz from '../../Cources/Course/ContentQuiz';
import User from '../../Users/User';
import Payments from '../../Payments';
import Assessments from '../../Assessments';
import Assessment from '../../Assessments/Assessment';
import BuyCourse from '../../Cources/Course/BuyCourse';
import Attendance from '../../Attendance';
import SessionDetails from '../../Attendance/SessionDetails';
import Notes from '../../Notes';
import MyCources from '../../MyCources';
import WishList from '../../WishList';
import { useSelector } from 'react-redux';
import WishListAdmin from '../../WishListAdmin';
import Certificates from '../../Certificates';
import Badges from '../../Badges';
import Centers from '../../Centers';
import RevenueAnalysis from '../../RevenueAnalysis';

const { Content } = Layout;

const ALL_ROLES = ['superadmin', 'admin', 'instructor', 'student', 'coordinator'];
const STAFF_ROLES = ['superadmin', 'admin', 'instructor', 'coordinator'];
const ADMIN_ROLES = ['superadmin', 'admin'];

const RoleRoute = ({ component: Component, allowedRoles, ...rest }) => {
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const userRole = userProfile?.role;

    return (
        <Route
            {...rest}
            render={(props) => {
                if (allowedRoles.includes(userRole)) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/dashboard/home" />;
                }
            }}
        />
    );
};

const DashboardContent = () => {
    const userProfile = useSelector(state => state.userProfile.userProfile);

    return (
        <Content className='dashboard-content'>
            <div className='site-layout-background'>
                <Switch>
                    <RoleRoute path='/dashboard/home' allowedRoles={ALL_ROLES} component={Home} />
                    <RoleRoute path='/dashboard/profile' allowedRoles={ALL_ROLES} component={User} />
                    <RoleRoute path='/dashboard/users/:id' allowedRoles={ALL_ROLES} component={User} />
                    <RoleRoute path='/dashboard/users' allowedRoles={ADMIN_ROLES} component={users} />

                    <RoleRoute path='/dashboard/cources/:id/content/:contentId/quiz' allowedRoles={ALL_ROLES} component={ContentQuiz} />
                    <RoleRoute path='/dashboard/cources/:id/buy' allowedRoles={['student']} component={BuyCourse} />
                    <RoleRoute path='/dashboard/cources/:id/edit' allowedRoles={['superadmin', 'admin', 'coordinator']} component={EditCourse} />
                    <RoleRoute path='/dashboard/cources/:id' allowedRoles={ALL_ROLES} component={Course} />
                    <RoleRoute path='/dashboard/cources' allowedRoles={ALL_ROLES} component={Cources} />

                    <RoleRoute path='/dashboard/mycources/:id' allowedRoles={['student']} component={Course} />
                    <RoleRoute path='/dashboard/mycources' allowedRoles={['student']} component={MyCources} />

                    <RoleRoute path='/dashboard/payments' allowedRoles={['superadmin', 'admin', 'student', 'instructor', 'coordinator']} component={Payments} />

                    <RoleRoute path='/dashboard/assessments/:id' allowedRoles={ALL_ROLES} component={Assessment} />
                    <RoleRoute path='/dashboard/assessments' allowedRoles={ALL_ROLES} component={Assessments} />

                    <RoleRoute path='/dashboard/attendance/:id' allowedRoles={STAFF_ROLES} component={SessionDetails} />
                    <RoleRoute path='/dashboard/attendance' allowedRoles={STAFF_ROLES} component={Attendance} />
                    
                    <RoleRoute path='/dashboard/notes' allowedRoles={ALL_ROLES} component={Notes} />

                    <RoleRoute path='/dashboard/wishlist' allowedRoles={['superadmin', 'admin', 'student']} component={userProfile?.role === 'student' ? WishList : WishListAdmin} />

                    <RoleRoute path='/dashboard/certificates' allowedRoles={['superadmin', 'admin', 'student', 'coordinator', 'instructor']} component={Certificates} />

                    <RoleRoute path='/dashboard/badges' allowedRoles={['superadmin', 'admin', 'student', 'coordinator', 'instructor']} component={Badges} />

                    <RoleRoute path='/dashboard/centers' allowedRoles={['superadmin']} component={Centers} />
                    <RoleRoute path='/dashboard/revenue' allowedRoles={['superadmin']} component={RevenueAnalysis} />
                    
                    <Redirect to="/dashboard/home" />
                </Switch>
            </div>
        </Content>
    )
}

export default DashboardContent